module.exports = __webpack_public_path__ + "img/assignMembers.22b9659b.png";